module.exports = __webpack_public_path__ + "img/img.f7fa1635.png";